<template>
  <div id="home">
    <div class="header_all">
      <div class="header_box">
        <div class="header_left">
          <table>
            <tr>
              <td rowspan="2" class="pr5 pt2"></td>
              <td class="hl_l">
                <router-link :to="{ name: 'home'}">
                  <div class="ht_tw">體育館及戶外場地租借</div>
                </router-link>
              </td>
              <td rowspan="2"></td>
            </tr>
          </table>
        </div>
        <div class="header_right text-right">
          <div class="lag mt10">
            <ul>
              <li v-if="role == 'YEARUSER'">Hi , {{name}}</li>
              <li>
                <router-link :to="{ name: 'account_app'}" v-if="role != 'YEARUSER'">
                  <button type="submit" class="yhbtn">登入</button>
                </router-link>
                <a v-if="role == 'YEARUSER'" @click="logOut">
                  <button type="submit" class="yhbtn">登出</button>
                </a>
              </li>
            </ul>
          </div>
          <div class="mt20 text-right">
            <div class="ytab_nav">
              <ul>
                <router-link :to="{ name: 'account_app'}" v-if="role != 'YEARUSER'">
                  <li>年度帳號申請</li>
                </router-link>
                <router-link :to="{ name: 'manage'}" v-if="role == 'YEARUSER'">
                  <li>年度帳號管理</li>
                </router-link>
                <a @click="goSiteInq">
                  <li>場地查詢申請</li>
                </a>
                <router-link :to="{ name: 'site_res'}" v-if="role == 'YEARUSER'">
                  <li>場地預約結果</li>
                </router-link>
                <router-link :to="{ name: 'site_int'}">
                  <li>場地介紹</li>
                </router-link>
                <router-link :to="{ name: 'account_info'}">
                  <li>申請帳號說明</li>
                </router-link>
                <div class="fix"></div>
              </ul>
            </div>
          </div>
        </div>
        <div class="fix"></div>
      </div>
    </div>
    <router-view ref="sub" v-if="!$route.meta.keepAlive"></router-view>
    <div class="content_all2" v-if="$route.meta.keepAlive">
      <div class="content_box">
        <div class="yleft">
          <HomeNotice></HomeNotice>
        </div>
        <div class="yright">
          <div class="list_box">
            <div class="y_ititle"><i class="fa fa-user mr5" aria-hidden="true"></i>會員登入</div>
            <div class="mt5 mb5">
              <input name="" type="text" class="input_style" placeholder="帳號" v-model="account">
            </div>
            <div class="mt5 mb5">
              <input name="" type="password" class="input_style" placeholder="密碼" v-model="password">
            </div>
            <div class="mt5 mb5">
              <vue-recaptcha ref="recaptcha" style="transform:scale(0.71);-webkit-transform:scale(0.71);transform-origin:0 0;-webkit-transform-origin:0 0;" @verify="onVerify" sitekey="6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"></vue-recaptcha>
            </div>
            <div class="tomi mt15">
              <button type="submit" class="btn_m" @click="loginClick">登入</button>
              <router-link :to="{ name: 'forpass' }">
                <button type="submit" class="btn_n">忘記密碼</button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="fix"></div>
      </div>
    </div>
    <div class="footer_all">
      <div class="footer_box">
        <div class="footer_left">
          <table>
            <tr>
              <td rowspan="2"></td>
            </tr>
          </table>
        </div>
        <div class="footer_right">
          台大綜合體育館版權所有 Copyright 2003-2005 NTU Sports Center All Rights Reserved
        </div>
        <div class="fix"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API } from '@/assets/project_setting/config';
import { ShowMessage, Message, RentStatusCode } from '@/assets/library/axiosErrorHandler';
import HomeNotice from '@/pages/rent/HomeNotice.vue'
import VueRecaptcha from 'vue-recaptcha';


export default {
  name: 'home',
  components: {
    HomeNotice,
    VueRecaptcha
  },
  data() {
    return {
      account: '',
      password: '',
      role: "",
      name: '',
      verifycode: ''
    };
  },
  created() {
    sessionStorage.setItem('locale', 'CH');
  },
  mounted() {
    if (sessionStorage.Role) {
      if (JSON.parse(sessionStorage.Role)['RENT']) {
        this.role = JSON.parse(sessionStorage.Role)['RENT'][0]
        this.name = sessionStorage.ContactName
      }
    }
    window.grecaptcha
  },
  watch: {
    '$route' (to, from) {
      if (sessionStorage.Role) {
        if (JSON.parse(sessionStorage.Role)['RENT']) {
          this.role = JSON.parse(sessionStorage.Role)['RENT'][0]
          this.name = sessionStorage.ContactName
        }
      }
    }
  },
  methods: {
    onSubmit: function() {
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify: function(response) {
      this.verifycode = response
      console.log(this.verifycode)
    },

    checkAccount() {
      if (!this.account) {
        throw new Error('請輸入帳號');
      }
    },
    checkPassword() {
      if (!this.password) {
        throw new Error('請輸入密碼');
      }
    },
    verify() {
      if (!this.verifycode) {
        throw new Error('請勾選驗證');
      }
    },
    loginClick() {
      try {
        this.checkAccount()
        this.checkPassword();
        this.verify();
      } catch (error) {
        alert(error.message);
        return;
      }

      let form = new FormData();
      this.$Loading.start();
      form.append('account', this.account);
      form.append("password", this.password);
      axios.post(API.rent_login, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {

          sessionStorage.clear();
          sessionStorage.setItem('locale', 'CH');
          sessionStorage.setItem('TokenID', response.data.tokenId);
          sessionStorage.setItem('Role', response.data.role);
          sessionStorage.setItem('Account', response.data.account);
          sessionStorage.setItem('YearUserId', response.data.id);
          sessionStorage.setItem('UnitName', response.data.unitName);
          sessionStorage.setItem('ContactName', response.data.contactName);
          sessionStorage.setItem('TeamType', response.data.teamType);
          sessionStorage.setItem('TeamTypeOther', response.data.teamTypeOther);
          sessionStorage.setItem('UnitType', response.data.unitType);
          if (JSON.parse(response.data.role)['RENT'].includes('YEARUSER')) {
            this.$router.replace({ name: 'manage' });
          } else {
            alert('帳號錯誤');
          }
        })
        .catch(error => {
          //例外處理

          let statusCode = parseInt(error.response.data.statusCode);
          for (let props in RentStatusCode) {
            if (statusCode === RentStatusCode[props]) {
              ShowMessage(Message[props][sessionStorage.locale]);
            }
          }
        });
    },
    logOut() {
      sessionStorage.clear();
      sessionStorage.setItem('locale', 'CH');
      this.role = ""
      this.name = ""
      this.$router.push({ name: 'home' });
    },
    goSiteInq() {
      this.$router.push({ name: 'site_inq' });
      // this.$refs.sub.initVenueid()
    }
  },
}

</script>
<style lang="scss">
@import "/../static/rent/css/plugins.css";
@import "/../static/rent/css/toastr.css";
@import "/../static/rent/css/set.css";
@import "/../static/rent/css/bi-style.css";
@import "/../static/rent/css/style.css";
.router-link-exact-active {
  li {
    text-shadow: rgb(255, 255, 255) 0px 1px 0px;
    color: rgb(64, 75, 87);
    background: linear-gradient(0deg, rgb(242, 242, 242), rgb(255, 255, 255));
    padding: 2px 20px 4px;
    border-width: 0px;
    border-style: initial;
    border-color: initial;
    border-image: initial;
  }
}

#home {
  .code {
    background-image: url(/../static/bg_1.jpg);
    font-family: Arial;
    font-style: italic;
    color: #a3a3a3;
    font-size: 22px;
    border: 0;
    padding: 2px 3px;
    letter-spacing: 3px;
    font-weight: bolder;
    cursor: pointer;
    width: 130px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    display: inline-block;
    margin-left: 10px;
  }
  .vile {
    a {
      text-decoration: none;
      font-size: 14px;
      color: #fff;
      font-weight: 500;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Home.vue?bbf3b1ec